import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

export interface SettingsSectionProps {
  title: string;
  children: ReactNode;
}

const Shell = styled.section({
  overflow: 'hidden',
  border: `1px solid ${t.color.border}`,
  borderRadius: t.radius.md,
  background: t.color.surface,
});

const Head = styled.header({
  padding: '1rem clamp(1rem, 3vw, 1.625rem)',
  borderBottom: `1px solid ${t.color.rowBorder}`,
  background: t.color.tableHeadBg,
  fontFamily: t.font,
  fontSize: '0.75rem',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: t.color.muted,
});

const Body = styled.div({
  '& > *:last-child': {
    borderBottom: 'none',
  },
});

/**
 * Tarjeta de una sección de ajustes con su encabezado y sus filas.
 */
const SettingsSection = ({ title, children }: SettingsSectionProps) => (
  <Shell>
    <Head>{title}</Head>
    <Body>{children}</Body>
  </Shell>
);

export default SettingsSection;
